module.exports = __webpack_public_path__ + "static/media/srightArrow.5e518027.svg";